<template>
<main-sidebar :name="name" :title="$tc('rate') | capitalize">
  <div class="p-4">
    <div class="vx-row">
      <div class="vx-col w-full mt-5">
        <vs-input :label="$t('from_or_equal') | capitalize" v-model="rate.fromOrEqual" class="w-full" name="From Or Equal" v-validate="'required|min_value:0'" />
        <span class="text-danger text-sm" v-show="errors.has('From Or Equal')">{{ errors.first('From Or Equal') }}</span>
      </div>
      <div class="vx-col w-full mt-5">
        <vs-input :label="$t('to_or_equal') | capitalize" v-model="rate.toOrEqual" class="w-full" name="To Or Equal" v-validate="'required|min_value:0'" />
        <span class="text-danger text-sm" v-show="errors.has('To Or Equal')">{{ errors.first('To Or Equal') }}</span>
      </div>
      <div class="vx-col w-full mt-5">
        <vs-input :label="$tc('rate') | capitalize" v-model="rate.rate" class="w-full" name="Rate" v-validate="'required|min_value:0'" />
        <span class="text-danger text-sm" v-show="errors.has('Rate')">{{ errors.first('Rate') }}</span>
      </div>
    </div>
  </div>

  <div class="mx-4" slot="footer">
    <vs-button color="primary" type="filled" class="mr-6" @click="submit" :disabled="disabledSubmit">
      {{ $t('save') | capitalize }}
    </vs-button>
    <vs-button color="primary" type="border" @click="close">
      {{ $t('cancel') | capitalize }}
    </vs-button>
  </div>
</main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate'
import client from '@/http/requests/client';
import mixins from '@/mixins'
export default {

  components: {
    MainSidebar,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.submit
    },
    disabledSubmit(){
      return this.errors.any()  || this.rate.fromOrEqual === '' || this.rate.toOrEqual === '' || this.rate.rate === ''
    }
  },
  data: () => ({
    name: 'rate',
    defaultRate:{
      id: '',
      fromOrEqual: '',
      toOrEqual: '',
      rate: ''
    },
    loading: {
      submit: false
    },
  }),
  methods: {
    add() {
      this.loading.submit = true
      let data = {
        ClientId: this.rate.clientId,
        FromGTorEqual: this.rate.fromOrEqual,
        ToLTorEqual: this.rate.toOrEqual,
        Rate: this.rate.rate,
      }
      client.addRate(data)
        .then((res) => {
          this.loading.submit = false
          this.close()
          this.$vs.notify({
            color: 'success',
            title: this.$i18n.messages[this.$i18n.locale].success,
            text: this.$i18n.messages[this.$i18n.locale].rate_saved
          });
          this.$emit('success')
        })
        .catch((res) => {
          this.displayErrors(res)
          this.loading.submit = false
        })
    },

    close() {
      this.$store.dispatch('toggleSidebar', '')
    },

    submit() {
      if (this.rate.id !== '') {
        this.update()
        return;
      }
      this.add()
    },

    update() {
      this.loading.submit = true
      let data = {
        FromGTorEqual: this.rate.fromOrEqual,
        ToLTorEqual: this.rate.toOrEqual,
        Rate: this.rate.rate,
        oldFromGTorEqual: this.defaultRate.fromOrEqual,
        oldToLTorEqual: this.defaultRate.toOrEqual,
        oldRate: this.defaultRate.rate,
      }
      client.updateRate(this.rate.clientId, data)
        .then((res) => {
          this.loading.submit = false
          this.close()
          this.$vs.notify({
            color: 'success',
            title: this.$i18n.messages[this.$i18n.locale].success,
            text: this.$i18n.messages[this.$i18n.locale].rate_updated
          });
          this.$emit('success')
        })
        .catch((res) => {
          this.ors(res)
          this.loading.submit = false
        })
    },

  },
  mixins: [loading, validate, mixins],
  props: {
    rate: {
      default: () => ({
        id: '',
        fromOrEqual: '',
        toOrEqual: '',
        rate: ''
      })
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
    isSidebarActive(val) {
      if (val) {
        this.defaultRate = Object.assign({},this.rate)
        this.$validator.reset()
      }
    },
  },
}
</script>

<style>
</style>
